import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const ChipWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  overflow: auto;
`

export const Chip = styled.div`
  border-radius: 8px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 500;
  color: ${myPalette.black.main};
  background: ${myPalette.blue['500']};
  border: none;
  display: flex;
  align-items: center;
  height: 24px;
`
